import React, { useState, useRef, useEffect } from "react";
import "./Home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
   const videoRef = useRef(null);
const [playing, setPlaying] = useState(false);
const playVideo = () => {
    const video = videoRef.current;

    if (!video) return;

    video.pause();
    video.currentTime = 0;

    video.play()
      .then(() => {
        setPlaying(true);
      })
      .catch((err) => {
        console.log("Playback failed:", err);
      });
  };

  const handlePause = () => {
    setPlaying(false);
  };

  const handleEnded = () => {
    setPlaying(false);
  };
var homeBanner = {
  autoplay: true,
  autoplaySpeed: 4000,
  dots: true,
  infinite: true,
  speed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true, // Fade animation
  cssEase: "ease-in-out"
};

  const testimonial_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // below 1024px screen width
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768, // below 768px screen width
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480, // below 480px screen width
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const service_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // below 1024px screen width
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // below 768px screen width
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // below 480px screen width
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  return (
    <>
      {/* bannner section */}
      <Slider {...homeBanner}>
        <div className="home-banner">
          <div className="banner-img">
            <img
              src={`${process.env.PUBLIC_URL}/assets/imgs/banner_img/banner_1.png`}
              alt="Banner_1"
            />
          </div>
          <div className="banner-content">
            <div className="container">
                  <div className="banner-info ">
                    <h1 className="font-semibold m-0 color-w">
                      One Community. Endless Possibilities.{" "}
                    </h1>
                    <a class="btn btn-default yellow_btn mt-4  rounded-pill font-semibold">
                      Click Here to Become a Foster Hero
                    </a>
                  </div>
            </div>
          </div>
        </div>

        <div className="home-banner">
          <div className="banner-img">
            <img
              src={`${process.env.PUBLIC_URL}/assets/imgs/banner_img/banner_2.png`}
              alt="Banner_1"
            />
          </div>
          <div className="banner-content">
            <div className="container">
                  <div className="banner-info ">
                  <h1 className="mb-3 color-w font_Size_50">
                      Pamper Your Pet with the Best!
                    </h1>
                   <p className=" color-w mb-0">Stock up on pet products and stylish accessories that will make their day.</p>

                    <a class="btn yellow_btn mt-4  rounded-pill font-semibold">
                      Shop Now
                    </a>
                  </div>
            </div>
          </div>
        </div>
         <div className="home-banner">
          <div className="banner-img">
            <img
              src={`${process.env.PUBLIC_URL}/assets/imgs/banner_img/banner_3.png`}
              alt="Banner_1"
            />
          </div>
          <div className="banner-content">
            <div className="container">
                  <div className="banner-info ">
                  <h1 className="mb-3 color-w font_Size_50">
                      Looking to Adopt a Pet?
                    </h1>
                    <p className="mb-0 color-w">Let’s get a new member in the family! <br></br>Here’s one waiting to love you.</p>

                    <a class="btn yellow_btn mt-4  rounded-pill font-semibold">
                      Click Here to Start Your Adoption Journey
                    </a>
                  </div>
            </div>
          </div>
        </div>
      </Slider>

      <section className="yellow_bg">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="about-content">
                <h1 className="font-semibold mb-4">
                    A Quick Pawzpective{" "}
                </h1>
                <p className="font-semibold">
                At Everything Pawzible, we believe every animal deserves care, comfort, and a loving home. What began as a simple effort to feed and support street animals has grown into a community-driven platform for pet care, adoption, and animal welfare.
              </p>
                <p className="font-semibold">
                We’re here to connect people, services, and support systems that make life better for pets and the animals who need us most.
                </p>
               { /*  <p className="font-semibold">
                Together, we can make a difference - one paw at a time
                <br></br>deserves. Join us. Let’s make
                  Everything Pawzible.
                </p>*/}
              </div>
            </div>
          </div>
<section className="spe-testimonial-section">
  <div className="">
    <div className="spe-testimonial-card">

    <div className="spe-testimonial-left">
  <div className="spe-testimonial-video-wrap">
  <video
    ref={videoRef}
    className="spe-testimonial-video"
    poster={`${process.env.PUBLIC_URL}/assets/imgs/video_poster.jpg`}
    controls={playing}
    onPlay={() => setPlaying(true)}
    onPause={() => setPlaying(false)}
    onEnded={() => setPlaying(false)}
  >
    <source
      src={`${process.env.PUBLIC_URL}/assets/video/avinash.mp4`}
      type="video/mp4"
    />
  </video>

  {!playing && (
    <>
      <div className="spe-testimonial-video-overlay"></div>

      <div
        className="spe-testimonial-play-btn"
        onClick={playVideo}
      >
        <i className="fas fa-play"></i>
      </div>
    </>
  )}
</div>
</div>

      <div className="spe-testimonial-right">

        <span className="spe-testimonial-label">
          TESTIMONIAL
        </span>

        <h2>
          Loved by Creators ❤️
        </h2>

        <p className="spe-testimonial-text">
          “Everything Pawzible is building more than a platform—it's creating a
          trusted community for pet parents. Their vision of connecting pets
          with verified services and compassionate people is something I truly
          admire. Wishing the team great success!”
        </p>

        <div className="spe-testimonial-user">
          <div>
            <h4>Avinash Agarwal</h4>
            <span>Animal Enthusiast</span>
          </div>

          <a
            href="https://instagram.com/avinashtheagarwal"
            target="_blank"
            rel="noreferrer"
            className="spe-testimonial-btn"
          >
            <i className="fab fa-instagram"></i>
            @avinashtheagarwal
          </a>
        </div>

      </div>

      <div className="spe-testimonial-quote">
        ❝
      </div>

    </div>
  </div>
</section>
          {/* <div className="row">
            <div className="col-md-12">
              <div className="about-content">
                <h1 className="font-semibold mb-4">Community</h1>
              </div>
            </div>
          </div> */}
          <div className="Community-container container-fluid mb-5">
            <div className="row">
              <div className="col-md-6">
                <div className="Community-content">
                  <h1 className="font-bold mb-4">
                    Join our community of animal lovers
                  </h1>
                  <p className="font-semibold">
                    At Everything Pawzible, we believe every wag, purr, and pawprint has the power to create a kinder world.
                     Join a community of passionate pet lovers who celebrate the joy, loyalty, and unconditional love our furry companions bring into our lives. <br></br>
                     <br></br>Together, we share stories, support animal welfare, inspire responsible pet parenting, and make a difference—one paw at a time. 
                     If your heart beats a little faster for animals, you’ve already found your tribe. </p>
                     <p className="font-semibold"><br></br>Welcome to Everything Pawzible, where every pet story matters. 🐾❤️
                  </p>
                  <a class="btn btn-dark rounded-pill px-4 w-mxcontent mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal">
                    Join Us Now
                  </a>
                </div>
              </div>
              <div className="col-md-6 pe-0">
                <div className="Community-image">
                  <img
                    className="w-100"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/Community.png`}
                    alt="Banner_1"
                  />
                </div>
              </div>
            </div>
          </div>


          <div className="row">
            <Slider className="service_slider" {...service_slider}>
 <div className="col-md-4">
              <div className="service">
                <div className="service_content">
                  <h4>Need Veterinary Care?  </h4>
                  <p className="font-semibold">
                    Find top-rated veterinary clinics near you for your pet's
                    health, well-being, care, and comfort!
                  </p>
                  <span className="coming-soon-badge">Coming Soon</span>
                </div>
                <div className="text-end">
                  <img
                    className="service_img"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/Vet.png`}
                    alt="Banner_1"
                  />
                </div>
                <a class="btn btn-dark rounded-4 py-4 w-100 font-semibold disabled">
                  Click Here to Find Care Nearby
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="service">
                <div className="service_content">
                  <h4>Going on Vacation? </h4>
                  <p className="font-semibold">
                    Whether it's a weekend getaway or a long trip, your furry
                    friend will be in the best hands!
                  </p>
                  <span className="coming-soon-badge">Coming Soon</span>
                </div>
                <div className="text-end">
                  <img
                    className="service_img"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/Home.png`}
                    alt="Banner_1"
                  />
                </div>
                <a class="btn btn-dark rounded-4 py-4 w-100 font-semibold disabled">
                  Book a Cozy Stay for Your Pet
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="service">
                <div className="service_content">
                  <h4>Celebrate Your Pet in Style! </h4>
                  <p className="font-semibold">
                    Find everything from event organizers to custom cakes and your friend's day unforgettable!
                    {/* more to make your furry friend's day unforgettable! */}
                    
                  </p>
                  <span className="coming-soon-badge">Coming Soon</span>
                </div>
                <div className="text-end">
                  <img
                    className="service_img"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/Pet party.png`}
                    alt="Banner_1"
                  />
                </div>
                <a class="btn btn-dark rounded-4 py-4 w-100 font-semibold disabled">
                  Plan the Perfect Pet Party
                </a>
              </div>
            </div>
          </Slider>
           
          </div>
        </div>
      </section>
      {/*<section className="yellow_bg pb-0">
        <Slider {...testimonial_slider}>
          <div className="testimonial_slider">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <div className="testimonial-content">
                    <h1 className="font-semibold mb-3">Our Friends</h1>
                    <p className="mb-0">
                      I am very happy to adopt Olivia. I was fortunate enough to
                      find her on EverythingPawzible
                    </p>
                    <p className="font-semibold mb-4">Ritika Singh</p>
                    <p className="font-semibold ">We're the Pet People.</p>
                    <a href="" className="font-semibold learn_more">
                      Learn more
                    </a>
                    <img
                      className="shape_img"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/shape.png`}
                      alt="Banner_1"
                    />
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div className="testimonial_slider-img">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/imgs/user.png`}
                      alt="Banner_1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>*/}
    </>
  );
};

export default Home;
